import { Component, Element, Event, EventEmitter, Host, h, Prop, State, Watch } from '@stencil/core';

export type SAccordionStackedToggleEvent = {
  newState: string;
  oldState: string;
};

@Component({
  tag: 's-accordion-stacked',
  styleUrl: 's-accordion-stacked.scss',
  shadow: false,
})
export class SAccordionStacked {
  @Element() element: HTMLSAccordionStackedElement;

  @Prop() open?: boolean;

  @Watch('open')
  openChanged(newValue: boolean) {
    this.isOpen = newValue;
  }

  @State() isOpen: boolean;

  @Event({
    eventName: 's-toggle',
    bubbles: true,
    composed: true,
  })
  toggleEvent: EventEmitter<SAccordionStackedToggleEvent>;

  #dispatchToggleEvent = event => {
    this.isOpen = event.newState === 'open';
    this.toggleEvent.emit({ newState: event.newState, oldState: event.oldState });
  };

  render() {
    return (
      <Host>
        <details onToggle={e => this.#dispatchToggleEvent(e)} open={!!this.open}>
          <summary>
            <div class="accordion-stacked-header-wrapper">
              <div class="accordion-stacked-header">
                <slot name="title"></slot>
                <slot name="title-accessory"></slot>
              </div>
              <s-icon class="i-expand-collapse" name={this.isOpen ? 'indeterminate' : 'plus'} aria-hidden="true"></s-icon>
            </div>
            <slot name="sub-heading"></slot>
          </summary>
          <slot></slot>
        </details>
      </Host>
    );
  }
}
